var React = require('react');

function ExclamationMarkColor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#feefae;}.cls-2{fill:#081319;}")),React.createElement("title",{"key":1},"warning-circle-colour"),React.createElement("path",{"data-style":"background","d":"M17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Z","key":2}),React.createElement("path",{"data-style":"inner-path","d":"M15.6,12.73,15.5,10h3l-.1,2.73L18,19H16Z","key":3}),React.createElement("circle",{"data-color":"black","cx":"17","cy":"22.5","r":"1.5","key":4})]);
}

ExclamationMarkColor.defaultProps = {"width":"34","height":"34","viewBox":"0 0 34 34"};

module.exports = ExclamationMarkColor;

ExclamationMarkColor.default = ExclamationMarkColor;
